import { name, version } from '../../package.json'

/** The packageDetails object has a get function that extracts fable package
 * name and version to be used in the `dataPkgId` prop of components */
export const packageDetails = {
  get: () => `${name}-${version}`,
  getMajor: () => `${name}-${version.split('.')[0]}`
}
